import React from 'react';
import ClientService from './../../../../service/client';
import ValidateService from './../../../../service/validate';
import { FORM_FIELD } from './../../core/abstract';
import mapStateToProps from './../../../../store/map/auth-token';
import mapDispatchToProps from './../../../../store/map/on-logout';
import { connect } from 'react-redux';
import SearchPrompt from './../../core/search';
import SearchUserSystemsViewPrompt from './view';
import theme from './../../../theme';

class _SearchUserSystemsPrompt extends SearchPrompt
{
    constructor(parms)
    {
        super(parms, _SearchUserSystemsPrompt.getValidators());

        this.getFieldsModel = this.getFieldsModel.bind(this);
        this.onSearchResponse = this.onSearchResponse.bind(this);
        this.onSearchError = this.onSearchError.bind(this);
        this.onSendToServer = this.onSendToServer.bind(this);
        this.getServerRequest = this.getServerRequest.bind(this);
        this.getSearchResultUi = this.getSearchResultUi.bind(this);
        this.onAuthError = this.onAuthError.bind(this);
        this.onFatalError = this.onFatalError.bind(this);
        this.onNetworkOffline = this.onNetworkOffline.bind(this);
        this.isUsingSubmitButton = this.isUsingSubmitButton.bind(this);
        this.getSearchResultsUi = this.getSearchResultsUi.bind(this);
    }

    static getValidators()
    {
        return {
            clientUserId: {
                isValid: ValidateService.anyValue
            }
        };
    }

    isUsingSubmitButton() 
    {
        return false;
    }


    onAuthError()
    {
        this.props.onLogout();
    }

    onFatalError()
    {
        this.props.onUpdateError(true, '');
    }

    onNetworkOffline()
    {
        this.props.onUpdateDeviceOnline(false);
    }

    getFieldsModel()
    {
        return {
            clientUserId: {
                name: 'User ID',
                error: 'Specify a userId',
                value: this.props.userId,
                visible: false,
                touched: false,
                type: FORM_FIELD.TEXT
            }
        };
    }

    onSearchResponse(response)
    {
        super.onSearchResponse(response, 'clientSystems');
    }

    onSendToServer(request = undefined)
    {
        ClientService.searchClientSystemsUser({
            request: request ? request : this.getServerRequest(),
            onResponse: this.onSearchResponse,
            onError: this.onSearchError,
            authToken: this.props.authToken,
            onAuthError: this.onAuthError,
            onFatalError: this.onFatalError,
            onNetworkOffline: this.onNetworkOffline
        });
    }

    getServerRequest()
    {
        return {
            page: 0,
            clientUserId: this.state.clientUserId.value
        };
    }

    onLoadSpecifiedPage(page)
    {
        this.setContactingServer(true);
        let request = this.getServerRequest();
        request.page = page;
        this.onSendToServer(request);
    }

    getNoResultsUi()
    {
        return (
            <div style={{
                ...theme.getGeneralTextStyle(theme)
            }}>
                <p>
                    No clients known for this user
                </p>
            </div>
        );
    }

    getSearchResultUi(aResult, index)
    {
        return <SearchUserSystemsViewPrompt aSystem={aResult} key={index} />
    }
}

const SearchUserSystemsPrompt = connect(mapStateToProps, mapDispatchToProps)(_SearchUserSystemsPrompt);
export default SearchUserSystemsPrompt;
